export default __webpack_public_path__ + "static/media/puerto_madryn.9aec5f04.jpg";